import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSettings } from '../useSettings';
import SlideCarousel from './SlideCarousel';
import AudioCarousel from './AudioCarousel';
import CustomPromptsDescription from './CustomPromptsDescription';
import SlideRequirements from './SlideRequirements';
import AudioRequirements from './AudioRequirements';
import LoadingMessage from '../utils/LoadingMessage';

function CustomPrompts() {
  const { promptsData, updatePromptsInfo } = useSettings();
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [showPromptError, setShowPromptError] = useState(false);
  const [promptError, setPromptError] = useState({});

  const tenantPrompts = promptsData?.customPrompts
    ? promptsData.customPrompts
    : [];
  const defaultPrompts = promptsData?.defaultPrompts
    ? promptsData.defaultPrompts
    : [];

  if (updatePromptsInfo && !updatePromptsInfo.task.isComplete) {
    return (
      <LoadingMessage
        message="Processing changes..."
        spinnerSize="sm"
        fontSize="1em"
      />
    );
  }

  if (defaultPrompts.length <= 0) {
    return (
      <LoadingMessage message="Loading..." spinnerSize="sm" fontSize="1em" />
    );
  }

  return (
    <>
      <CustomPromptsDescription />
      <SlideCarousel
        onSlideChange={setCarouselIndex}
        defaultPrompts={defaultPrompts}
        tenantPrompts={tenantPrompts}
        carouselIndex={carouselIndex}
        setShowPromptError={setShowPromptError}
        setPromptError={setPromptError}
      />
      <AudioCarousel
        tenantPrompts={tenantPrompts}
        defaultPrompts={defaultPrompts}
        carouselIndex={carouselIndex}
        setShowPromptError={setShowPromptError}
        setPromptError={setPromptError}
      />
      <Modal
        show={showPromptError}
        onHide={() => setShowPromptError(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>{promptError.title}</Modal.Header>
        <Modal.Body>
          {promptError.message}
          {promptError.isSlide ? <SlideRequirements /> : <AudioRequirements />}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CustomPrompts;
